import type { OAuthLoginData } from "@/betby/api/types";
import {
  getHttpRuntime,
  type HttpRuntimeAuthSnapshot,
} from "@/betby/infrastructure/http/httpRuntime";
import { logger } from "@/betby/api/httpLogger";

const emptyAuthSnapshot: HttpRuntimeAuthSnapshot = {
  accessToken: null,
  refreshToken: null,
  expiresTime: null,
  userId: null,
  productId: null,
  businessId: null,
  userInfo: null,
  loginData: null,
  isAuthenticated: false,
};

export function getAuthSnapshot(): HttpRuntimeAuthSnapshot {
  const snapshot = getHttpRuntime().getAuthSnapshot?.();
  if (snapshot) {
    return snapshot;
  }

  logger.warn("[http] HttpRuntime.getAuthSnapshot 未注册，使用空认证快照");
  return emptyAuthSnapshot;
}

export function clearAuthState(): void {
  const runtime = getHttpRuntime();
  if (runtime.clearAuth) {
    runtime.clearAuth();
    return;
  }

  logger.warn("[http] HttpRuntime.clearAuth 未注册，跳过 clearAuth");
}

export function notifyTokenExpired(message?: string, title?: string): void {
  const runtime = getHttpRuntime();
  if (runtime.onTokenExpired) {
    runtime.onTokenExpired(message, title);
    return;
  }

  logger.warn(
    "[http] HttpRuntime.onTokenExpired 未注册，跳过 tokenExpired 通知",
  );
}

export function notifyLoginRequired(): void {
  const runtime = getHttpRuntime();
  if (runtime.onLogin) {
    runtime.onLogin();
    return;
  }

  logger.warn(
    "[http] HttpRuntime.onLogin 未注册，跳过 login 通知",
  );
}

export function applyLoginData(
  data: OAuthLoginData,
  responseTimestamp?: number,
): void {
  const runtime = getHttpRuntime();
  if (runtime.applyLoginData) {
    runtime.applyLoginData(data, responseTimestamp);
    return;
  }

  logger.warn("[http] HttpRuntime.applyLoginData 未注册，跳过登录数据写入");
}
